import { render, staticRenderFns } from "./ExpensePeriodMembers.vue?vue&type=template&id=4c227f84"
import script from "./ExpensePeriodMembers.vue?vue&type=script&lang=js"
export * from "./ExpensePeriodMembers.vue?vue&type=script&lang=js"
import style0 from "./ExpensePeriodMembers.vue?vue&type=style&index=0&id=4c227f84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports